<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="filterRecord.PageType"
              :items="pageTypeList"
              item-text="Name"
              item-value="Type"
              label="頁面"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filterRecord.ActionType"
              :items="actinTypeList"
              item-text="Name"
              item-value="Type"
              label="動作"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field v-model="filterRecord.UserName" label="異動人"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <date-picker-set-time-not-request
              :time="filterRecord.StartChangeTime"
              :dateName="'common_start_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setStartTime"
            />
          </v-col>
          <v-col>
            <date-picker-set-time-not-request
              :time="filterRecord.EndChangeTime"
              :dateName="'common_end_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setEndTime"
            />
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getRecordList">
              {{ $t('common_search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="recordDataTableHeaders"
      :items="recordList"
      class="elevation-1 mt-5"
      :loading="isLoadingRecord"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:[`item.ChangeTime`]="{ item }">
        {{ convertToDateTimeFormat(item.ChangeTime) }}
      </template>
      <template v-slot:[`item.PageType`]="{ item }">
        {{ turnPageType(item.PageType) }}
      </template>
      <template v-slot:[`item.ActionType`]="{ item }">
        {{ turnActionType(item.ActionType) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpPageChangeRecord } from '@/js/http-Manager'
import { PageType } from '@/js/PageType'
import { ActionType } from '@/js/ActionType'
import DatePickerSetTimeNotRequest from '@/components/DatePickerSetTimeNotRequest.vue'
export default {
  components: { DatePickerSetTimeNotRequest },
  name: 'PageChangeRecord',
  data: () => ({
    filterRecord: {
      PageType: null,
      StartChangeTime: 0,
      EndChangeTime: 0,
      UserName: '',
      ActionType: null
    },
    recordList: [],
    isLoadingRecord: false,
    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    actinTypeList: [],
    pageTypeList: []
  }),
  async mounted () {
    await this.getRecordList()
    await this.countTotalRows()
    await this.getActionTypeList()
    await this.getPageTypeList()
  },
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    recordDataTableHeaders () {
      return [
        { text: '頁面', align: 'start', value: 'PageType' },
        { text: '唯一值', align: 'start', value: 'PageId' },
        { text: '異動時間', align: 'start', value: 'ChangeTime' },
        { text: '異動人', align: 'center', value: 'UserName' },
        { text: '動作', align: 'center', value: 'ActionType' }
      ]
    }
  },
  methods: {
    async getActionTypeList () {
      let response = await HttpPageChangeRecord.GetActionTypes()
      this.actinTypeList = response && response.status === 200 ? response.data.Data : []
    },
    async getPageTypeList () {
      let response = await HttpPageChangeRecord.GetPageTypes()
      this.pageTypeList = response && response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          PageType: this.filterRecord.PageType,
          StartChangeTime: this.filterRecord.StartChangeTime,
          EndChangeTime: this.filterRecord.EndChangeTime,
          UserName: this.filterRecord.UserName,
          ActionType: this.filterRecord.itemsPerPage
        }
        let response = await HttpPageChangeRecord.GetAllRecordCount(param)
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    async getRecordList (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        await this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingRecord = true
      let param = {
        PageType: this.filterRecord.PageType,
        StartChangeTime: this.filterRecord.StartChangeTime,
        EndChangeTime: this.filterRecord.EndChangeTime,
        UserName: this.filterRecord.UserName,
        ActionType: this.filterRecord.ActionType,
        PerPage: val && val.itemsPerPage ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: val && val.page ? val.page : this.currentOptions.page,
        SortBy: val && val.sortBy ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: val && val.sortDesc ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }
      let response = await HttpPageChangeRecord.GetAllRecord(param)
      this.isLoadingRecord = false
      if (response) {
        this.recordList = response.status === 200 ? response.data.Data : []
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getRecordList(val)
    },
    convertToDateTimeFormat (timestamp) {
      return this.$moment(new Date(timestamp)).format('YYYY-MM-DD HH:mm:ss')
    },
    turnPageType (val) {
      return PageType.PageTypeName(val)
    },
    turnActionType (val) {
      return ActionType.ActionTypeName(val)
    },
    setStartTime (val) {
      this.filterRecord.StartChangeTime = val * 1
      if (this.filterRecord.StartChangeTime > this.filterRecord.EndChangeTime) {
        this.filterRecord.EndChangeTime = this.filterRecord.StartChangeTime
      }
    },
    setEndTime (val) {
      this.filterRecord.EndChangeTime = val * 1
      if (this.filterRecord.StartChangeTime > this.filterRecord.EndChangeTime) {
        this.filterRecord.StartChangeTime = this.filterRecord.EndChangeTime
      }
    }
  }
}
</script>
